import { ReactElement, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TabsProps } from 'antd';

import { LenderBdmsSection, LenderDetailsSection, LenderProcurationFeesSection, LenderRegionsSection } from '@pmp/components';
import { usePmpFetch, useListTabParam } from '@pmp/hooks';
import { Page, StyledTabs } from '@ohpen/enso-ui';

import styles from './styles.module.css';

export const LenderPage = (): ReactElement => {
  const { t } = useTranslation();
  const [isFetching, , lender, , fetchLender] = usePmpFetch('lendersGetLender');

  useEffect(() => {
    fetchLender();
  }, [fetchLender]);

  const tabItems: TabsProps['items'] = useMemo(() => {
    const items = [
      {
        key: 'details',
        label: t('lender.lender.labels.complianceConfiguration'),
        children: <LenderDetailsSection details={lender ?? null} isFetching={isFetching} refresh={fetchLender} />,
      },
      {
        key: 'procuration-fees',
        label: t('lender.lender.labels.defaultProcurationFees'),
        children: <LenderProcurationFeesSection />,
      },
      {
        key: 'regions',
        label: t('lender.regionsBdms.labels.regions'),
        children: <LenderRegionsSection />,
      },
      {
        key: 'bdms',
        label: t('lender.regionsBdms.labels.bdms'),
        children: <LenderBdmsSection />,
      },
    ];

    return items;
  }, [fetchLender, isFetching, lender, t]);

  const tabKeys = useMemo(() => (tabItems ?? []).map(item => String(item.key)), [tabItems]);
  const tabParam = useListTabParam(tabKeys);

  return (
    <Page>
      <Page.Title>{t('lender.lender.title')}</Page.Title>
      <Page.Content>
        <StyledTabs {...tabParam} items={tabItems} className={styles.tabs} />
      </Page.Content>
    </Page>
  );
};
